module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("For my mom—the most cinematic woman I know.")])]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("To my four grandparents. My grandfather Melvyn Douglas told me, “When you find someone you can learn from, hold on to them.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a307caa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 66
// module chunks = 0